// test2496
(2496 && 0);
